import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFacebook,
  faInstagram,
  faLinkedin,
  faYoutube ,
  faWhatsapp,
} from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import '../styles/footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-left">
          <strong>Contact Us</strong>
          <div className="footer-icons">
            <a href="mailto:onenessence963@gmail.com" title="Email">
              <FontAwesomeIcon icon={faEnvelope} />
            </a>
<a
  href="https://wa.me/917396502963"
  aria-label="Chat on WhatsApp"
  target="_blank"
  rel="noreferrer"
>
  <FontAwesomeIcon icon={faWhatsapp} />
</a>

          </div>
        </div>

        <div className="footer-right">
          <strong>Follow Us</strong>
          <div className="footer-icons">
            <a href="https://facebook.com" target="_blank" rel="noreferrer">
              <FontAwesomeIcon icon={faFacebook} />
            </a>
            <a href="https://instagram.com/one_n_essence" target="_blank" rel="noreferrer">
              <FontAwesomeIcon icon={faInstagram} />
            </a>
            <a href="https://linkedin.com/in/divya-jyoti-b7745a35a" target="_blank" rel="noreferrer">
              <FontAwesomeIcon icon={faLinkedin} />
            </a>
            <a href="https://www.youtube.com/@Onenessesnce" target="_blank"  rel="noreferrer"  aria-label="YouTube Channel">
             <FontAwesomeIcon icon={faYoutube} />
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        © 2026 Onenessence. All rights reserved.
      </div>
    </footer>
  );
}
